import { render, staticRenderFns } from "./SurfaceLoadTable.vue?vue&type=template&id=01a56fe2"
import script from "./SurfaceLoadTable.vue?vue&type=script&lang=ts"
export * from "./SurfaceLoadTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a56fe2')) {
      api.createRecord('01a56fe2', component.options)
    } else {
      api.reload('01a56fe2', component.options)
    }
    module.hot.accept("./SurfaceLoadTable.vue?vue&type=template&id=01a56fe2", function () {
      api.rerender('01a56fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/SurfaceLoadTable.vue"
export default component.exports